import { AddressFieldInfo } from 'utils/hooks/useAddress'
import * as Yup from 'yup'

export const editAddressValidationSchema = (
  addressField: AddressFieldInfo,
  isUkValidation: boolean
) =>
  Yup.object().shape({
    city: Yup.string()
      .min(2, 'Must contain at least 2 characters')
      .max(50, 'Must contain less than 50 characters')
      .required()
      .label(addressField.city.errorLabel),
    state: isUkValidation
      ? Yup.string().label(addressField.state.errorLabel)
      : Yup.string().required().label(addressField.state.errorLabel),
    postalCode: Yup.string()
      .required()
      .label(addressField.postalCode.errorLabel),
    address: Yup.string()
      .max(100, 'Must contain less than 100 characters')
      .required()
      .label(addressField.address.errorLabel),
    address2: Yup.string()
      .optional()
      .max(100, 'Must contain less than 100 characters')
      .label(addressField.address2?.errorLabel || 'Unit Number'),
  })
